import { api } from "../../../../services/api";
import { handleApiErrorResponse, transformApiResponse } from "../../../../utils/api";
export const LOGOUT_PATH = "/auth/logout";
export const PULSE_LOGOUT_EVENT = "PULSE_LOGOUT_EVENT";
export const logoutApi = api
    .injectEndpoints({
    endpoints: (build) => ({
        logout: build.mutation({
            query() {
                return {
                    url: LOGOUT_PATH,
                    method: "POST"
                };
            },
            transformResponse: (response) => {
                localStorage.setItem(PULSE_LOGOUT_EVENT, Date.now().toString());
                return transformApiResponse(response);
            },
            transformErrorResponse: () => handleApiErrorResponse("Error logging out.")
        })
    })
});
export const { useLogoutMutation } = logoutApi;
